import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import GuestFaceList from './components/GuestFaceList'


const { Cell } = ResponsiveGrid;

const GuestFace = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="人臉訪客列表"
        breadcrumbs={[
          {
            name: '人臉訪客',
          },
          {
            name: '人臉訪客列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <GuestFaceList />
    </Cell>
  </ResponsiveGrid>
);

export default GuestFace;
